export default __webpack_public_path__ + "static/media/chen_qian.b74c8123.pdf";